import React, {useEffect} from "react";
import styled from "@emotion/styled/macro";
import Logo from "../_common/component/Logo";
import LoginForm from "./component/LoginForm";
import {useTheme} from "@emotion/react";
import {getImageUrl, useApplicationContext} from "../../context/ApplicationContextProvider";
import {HEADER_TYPE_NONE} from "../_common/section/Header";
import {FOOTER_TYPE_NONE} from "../_common/section/Footer";
import {useMobileDetect} from "../../utils/Hooks";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {account_actions} from "../../redux/slice/AccountReducer";
import {cache_actions} from "../../redux/slice/CacheReducer";

const ContainerMain = () => {
    // ApplicationContext
    useApplicationContext({
        header: {
            type: HEADER_TYPE_NONE,
        },
        footer: {
            type: FOOTER_TYPE_NONE,
        },
    });

    const {is_mobile} = useMobileDetect();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const account_reducer = useSelector((state) => state.account_reducer);

    //css style
    const {view} = useComponentStyle(is_mobile);

    useEffect(() => {
        if (account_reducer.info && account_reducer.token && account_reducer.is_login) {
            navigate("/course-list");
        } else {
            dispatch(account_actions.doLogout());
            dispatch(cache_actions.removeAll());
        }
    }, [dispatch, account_reducer.info, account_reducer.token, account_reducer.is_login, navigate]);

    return (
        <>
            <view.TitleSection>
                <div className="logo_box">
                    <Logo header={false} />
                </div>
                <view.Title>
                    <p>
                        베어유 비지니스에서
                        <br />
                        커리어 성장을 이루세요
                    </p>
                    <view.SubTitle>당신의 커리어를 응원합니다</view.SubTitle>
                    <view.BearImg />
                </view.Title>
            </view.TitleSection>
            <LoginForm />
            <view.CreateAccountInfoSection>
                <span>
                    계정 생성 문의는 귀사 B2B담당자 또는
                    {is_mobile && <br />}
                    bear-u@tendom.co.kr
                </span>
            </view.CreateAccountInfoSection>
        </>
    );
};

export default ContainerMain;

export const useComponentStyle = (is_mobile) => {
    const theme = useTheme();
    return {
        view: {
            TitleSection: styled.div({
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                minWidth: "260px",
                height: "19em",
                background: "linear-gradient(to right, #213a7a, #3e2f9f)",
                minHeight: "15em",
                "& > .logo_box": {
                    height: "20%",
                },
            }),
            Title: styled.div({
                display: "flex",
                marginTop: is_mobile ? ".8em" : ".8em",
                width: "100%",
                maxWidth: "400px",
                flexDirection: "column",
                position: "relative",
                height: "90%",
                fontSize: is_mobile ? "1.9em" : "2em",
                whiteSpace: "nowrap",
                fontWeight: "700",
                color: theme.colors.w,
                "@media (max-width: 320px)": {
                    alignItems: "center",
                },
                "& p": {
                    margin: "0",
                    textAlign: is_mobile && "center",
                    transition: "all .2s",
                    "@media (max-width: 320px)": {
                        fontSize: ".9em",
                    },
                },
            }),
            SubTitle: styled.span({
                display: "block",
                fontSize: is_mobile ? ".6em" : ".5em",
                fontWeight: "400",
                marginTop: is_mobile ? ".5em" : "1em",
                textAlign: is_mobile && "center",
                transition: "all .2s",
                "@media (max-width: 320px)": {
                    fontSize: ".55em",
                },
            }),
            BearImg: styled.div({
                position: "absolute",
                width: "3em",
                height: "3em",
                bottom: "-5%",
                right: is_mobile ? "40%" : "0",
                background: `url(${getImageUrl("image/home/logo_bear_img_x3.png")}) center center/contain no-repeat`,
                zIndex: "1000",
                "@media (max-width: 320px)": {
                    right: "34%",
                },
            }),
            CreateAccountInfoSection: styled.div({
                width: "100%",
                maxWidth: "400px",
                margin: "5em auto 2em auto",
                transition: "all .2s",
                minWidth: "260px",
                span: {
                    color: theme.colors.dg2,
                    fontSize: theme.font_size.f15,
                },
                "@media (max-width: 768px)": {
                    textAlign: "center",
                },
            }),
        },
    };
};
